import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { type ApplicationConfig, Injectable, importProvidersFrom, inject, isDevMode, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { SharedAzureAuthModule } from '@dtis/angular';
import { provideTransloco, type Translation, type TranslocoLoader } from '@jsverse/transloco';
import { provideStore } from '@ngxs/store';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { urlRewriteInterceptor } from './interceptors/url-rewrite.interceptor';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    provideStore([], { developmentMode: !environment.production }),
    provideHttpClient(withInterceptors([urlRewriteInterceptor]), withInterceptorsFromDi()),
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    importProvidersFrom(SharedAzureAuthModule.forRoot(environment)),
  ],
};
